import { axiosApiInstance, USER_ENDPOINT } from "endpoint/index";
import camelcaseKeys from "camelcase-keys";

const getPackages = async () => {
  const response = await axiosApiInstance.get(`${USER_ENDPOINT}/list-package`);
  return camelcaseKeys(response.data, { deep: true });
};

export default getPackages;
